<template>
  <div class="interview" v-if="rendData">
    <div class="bg" :style="'background-image: url(' + company_data.logo_url + ')'"></div>
    <div class="content">
      <div class="logo">
        <van-image fit="cover" width="1rem" height="1rem" :src="company_data.logo_url" />
      </div>
      <div class="text">
        <p class="company-name">{{company_data.company_name}}</p>
        <p v-if="parseInt(interview_data.interview_state) === 1 || notify">邀请你进行视频面试</p>
        <p v-else>
          <span v-if="interview_data.interview_time">你的面试时间为{{interview_data.interview_time}},请耐心等待</span>
          <span v-else>您的面试时间还未确定,请耐心等待</span>
        </p>
      </div>
      <footer v-if="parseInt(interview_data.interview_state) === 1 || notify">
        <van-row>
          <van-col span="12" @click="refuseFn">
            <span class="video video-hangeup">
              <span class="iconfont icon-tubiao-"></span>
            </span>
            <p>拒绝</p>
          </van-col>
          <van-col span="12" @click="acceptFn">
            <span class="video">
              <span class="iconfont icon-Icon-shipin"></span>
            </span>
            <p>面试</p>
          </van-col>
        </van-row>
      </footer>
      <div v-else>
        <van-button type="info" @click="backFn" style="min-width: 1rem;">返回</van-button>
      </div>
    </div>
    <audio
      style="display:none; height: 0"
      id="bg-music"
      ref="audioMusic"
      autoplay
      preload="auto"
      :src="audioSrc"
      loop="loop"
    ></audio>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "interview",
  components: {},
  computed: {
    ...mapState({
      route: state => state.route,
      global_invitation_apply_id: state => state.invitation_apply_id,
      sign: state => state.sign,
      companyOnline: state => state.companyOnline,
      user_name: state => state.user_name,
      seeker_openid: state => state.seeker_openid
    })
  },
  data() {
    return {
      rendData: false,
      invitation_apply_id: "",
      company_data: {},
      interview_data: {},
      audioSrc: "",
      audio: {
        call: "audio/call.mp3",
        hange_up: "audio/hang-up.mp3"
      },
      notify: ""
    };
  },
  created() {
    this.$store.commit("updateQuickFace", false);
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let invitation_apply_id = this.$util.getQueryString(
        "invitation_apply_id"
      );

      this.notify = this.$util.getQueryString("notify") || "";

      if (invitation_apply_id) {
        this.invitation_apply_id = invitation_apply_id;
        this.getDetail();
      } else {
        this.$router.push({ path: "/" });
      }
    },
    getDetail() {
      let that = this;
      return new Promise(resolve => {
        const { invitation_apply_id, sign } = that;
        const params = {
          invitation_apply_id,
          sign
        };

        that.$util
          .get("kzp_video_jobfair", "video_invitation_detail", params)
          .then(res => {
            const { code, msg, data } = res;
            if (code === 1) {
              that.interview_data = data;
              if (
                parseInt(that.interview_data.interview_state) === 1 ||
                that.notify
              ) {
                that.startAudio(that.audio.call);
              }
              const { company_data } = data || {};
              if (company_data) {
                that.company_data = company_data;
              }
              that.rendData = true;
            } else {
              that.$notify({
                message: msg || "获取数据失败，请稍后再试！",
                type: "danger",
                onClose: () => {
                  that.$router.push({ path: "/" });
                }
              });
            }
            resolve(res);
          });
      });
    },
    backFn() {
      try {
        // this.startAudio(this.audio.hange_up);
        // this.audioSrc = this.audio.hange_up;

        this.musicPlay(false);

        this.$dialog.close();

        this.$router.go(-1);
      } catch (error) {
        this.$router.push({ path: "/" });
      }
    },
    refuseFn() {
      // TODO:: 通知企业已拒绝面试
      const { invitation_apply_id, interview_data } = this;

      this.$dialog
        .confirm({
          title: "拒绝",
          message: "确定拒绝?"
        })
        .then(() => {
          this.dealInterview();

          this.$store.commit("update_refused_face", {
            key: invitation_apply_id,
            val: interview_data
          });
          this.$store.commit("update_invitation_apply_id", 0);
          this.backFn();
        })
        .catch(() => {
          // on cancel
        });
    },
    acceptFn() {
      let that = this;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner"
      });

      const { interview_data } = this;

      const { invitation_apply_id } = interview_data;

      that.musicPlay(false);

      setTimeout(() => {
        that.backFn();
      }, 500);

      // 发送接受面试
      that.dealInterview(true)

      // 进入面试房间
      that.$store.commit("update_invitation_apply_id", invitation_apply_id);
    },
    // 音乐播放
    autoPlayMusic() {
      let that = this;

      // 自动播放音乐效果，解决浏览器或者APP自动播放问题
      function musicInBrowserHandler() {
        that.musicPlay(true);
        document.body.removeEventListener("touchstart", musicInBrowserHandler);
      }

      that.musicPlay(true);

      document.body.addEventListener("touchstart", musicInBrowserHandler);

      document.removeEventListener("DOMContentLoaded", that.autoPlayAudio);
    },
    musicPlay(isPlay) {
      var media = document.querySelector("#bg-music");
      if (!media) {
        return;
      }
      if (isPlay && media.paused) {
        media.play();
      }

      if (!isPlay && !media.paused) {
        media.pause();
      }
    },
    autoPlayAudio() {
      let that = this;
      var audio = document.querySelector("#bg-music");

      try {
        audio.play();
      } catch (error) {
        console.log(error);
      }

      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          audio.play();
        },
        false
      );

      this.$wechat.ready(function() {
        that.musicPlay(true);
        audio.play();
      });
    },
    startAudio(audioSrc) {
      this.audioSrc = audioSrc;
      this.autoPlayMusic();
      this.notifyAlert();
    },
    notifyAlert() {
      if (this.$util.ismobile("isAndroid")) {
        return;
      }

      // ios 弹出提示需要确定, 兼容ios的声音
      let that = this;
      that.$dialog
        .alert({
          title: "温馨提示",
          message: "点击面试即将开始面试!"
        })
        .then(() => {
          // on close
        });
    },
    dealInterview(param) {
      let { invitation_apply_id, interview_data } = this;
      if (invitation_apply_id) {
        // 发送拒绝面试
        this.$store.commit("update_single_state", {
          key: "websocket_send_data",
          data: {
            flag: "notice",
            msg_from: "user",
            receiver_uid: interview_data.video_erp_register_id,
            business_type: '处理面试',
            business_id: invitation_apply_id,
            business_txt: param ? 1: 0
          }
        });
      }
    }
  },
  watch: {
    global_invitation_apply_id: {
      handler(val, oldVal) {
        console.log(val, oldVal);
        if (val < 0 && oldVal >= 0) {
          this.$store.commit("update_invitation_apply_id", 0);
          this.backFn();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.interview {
  position: relative;

  > div {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  > .bg {
    z-index: 1;
    background-position: center center;
    background-repeat: no-repeat;
    @include background-size(cover);
    @include opacity(0.1);
  }

  > .content {
    padding-top: 1rem;
    z-index: 10;
    background-color: rgba(33, 33, 33, 0.5);
    color: #fff;
    text-align: center;

    @include box-sizing(border-box);

    .text {
      font-size: 0.14rem;
      line-height: 0.2rem;
      margin-bottom: 0.62rem;

      p {
        padding: 0.025rem;
      }
    }

    .company-name {
      font-size: 0.18rem;
      line-height: 0.25rem;
      // font-weight: bold;
    }

    .logo {
      width: 1rem;
      height: 1rem;
      margin: 0 auto;
      background-color: #fff;
      margin-bottom: 0.2rem;
      overflow: hidden;
      @include border-radius(0.06rem);
    }
  }

  footer {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0.6rem;

    p {
      margin-top: 0.08rem;
      font-size: 0.12rem;
      line-height: 0.14rem;
    }

    .iconfont {
      font-size: 0.4rem;
    }

    .video {
      display: inline-block;
      width: 0.68rem;
      height: 0.68rem;
      text-align: center;
      line-height: 0.68rem;
      @include border-radius(50%);
      background-color: #439bff;
      color: #fff;
    }

    .video-hangeup {
      background-color: #ff3636;
    }
  }
}
</style>
